<script setup lang="ts">
/**
 * RinganDropzone — padanan <CaDropzone>, hanya menukar <UIcon> dengan SVG inline.
 *
 * Di HP tidak ada "drag and drop": yang penting area sentuh BESAR dan teksnya
 * menyebut galeri/kamera, bukan istilah desktop. Kontrolnya tetap
 * <input type="file"> asli (a11y + akses kamera Android), disembunyikan lewat
 * `sr-only` dan bukan `display:none` — supaya tetap terjangkau pembaca layar.
 */
const props = withDefaults(
  defineProps<{
    accept?: string
    multiple?: boolean
    judul?: string
    catatan?: string
  }>(),
  {
    accept: 'image/*',
    multiple: true,
    judul: 'Pilih berkas',
    catatan: 'JPG, PNG, atau PDF · maksimal 20 MB per berkas'
  }
)
const emit = defineEmits<{ pilih: [File[]] }>()

const seret = ref(false)
const input = ref<HTMLInputElement | null>(null)

function terima(list: FileList | null) {
  if (!list?.length) return
  emit('pilih', Array.from(list))
}
function jatuh(e: DragEvent) {
  seret.value = false
  terima(e.dataTransfer?.files ?? null)
}
</script>

<template>
  <div
    class="rounded-card border-2 border-dashed transition-colors duration-[180ms]"
    :class="seret ? 'border-brand bg-brand-soft' : 'border-line-strong bg-surface-2'"
    @dragover.prevent="seret = true"
    @dragleave.prevent="seret = false"
    @drop.prevent="jatuh"
  >
    <button
      type="button"
      class="ca-focus w-full min-h-40 flex flex-col items-center justify-center gap-2 px-5 py-8 text-center rounded-card"
      @click="input?.click()"
    >
      <span class="grid place-items-center size-12 rounded-full bg-brand-soft">
        <RinganIkon nama="upload" class="size-6 text-brand" />
      </span>
      <span class="ca-h3 mt-1">{{ props.judul }}</span>
      <span class="ca-caption text-muted max-w-xs">{{ props.catatan }}</span>
      <span class="ca-caption text-brand font-semibold mt-1">Ketuk untuk ambil dari galeri</span>
    </button>
    <input
      ref="input"
      type="file"
      class="sr-only"
      :accept="props.accept"
      :multiple="props.multiple"
      @change="terima(($event.target as HTMLInputElement).files)"
    >
  </div>
</template>
